import * as monaco from 'monaco-editor';
import loader from '@monaco-editor/loader';

loader.config({ monaco,  'vs/nls': { availableLanguages: { '*': 'zh-cn' } }});

export const monacoHolder: { value: typeof monaco } = {} as any;

export async function monacoInit() {
  loader.init().then((m) => (monacoHolder.value = m));
}
